import { api as apiProvider, apiMipe } from '@/core/api/';

const baseApiURL = 'api/beca';
const baseApiReport = 'api/report';

export const getAdvanceFilters = () =>
  apiProvider.get(`${baseApiURL}/advancedfilters`);
export const getAllYearsForLoadProcess = () =>
  apiProvider.get(`${baseApiURL}/allyears`);
export const getPeriods = (academicYearId) =>
  apiProvider.get(`${baseApiURL}/periods`, {
    params: {
      academicYearId,
    },
  });
export const getServices = (academicYearId, monthNumber) =>
  apiProvider.get(`${baseApiURL}/services`, {
    params: {
      academicYearId,
      monthNumber,
    },
  });

export const searchScholarship = (payload) =>
  apiProvider.get(`${baseApiURL}/assistancesummarydetails`, {
    params: {
      ...payload,
    },
  });

export const searchFindings = (payload) =>
  apiProvider.get(`${baseApiURL}/getvalidationerrorlogs`, {
    params: {
      ...payload,
    },
  });

export const searchScholarshipProgress = (payload) =>
  apiProvider.get(`${baseApiURL}/assistancedetailipmaster`, {
    params: {
      ...payload,
    },
  });

export const getAssistancesBatchLoad = (data) =>
  apiProvider.get(`${baseApiURL}/assistancebatchloadcontrol`, {
    params: data,
  });

export const updateLoadProcess = async (parameters) =>
  apiProvider.post(`${baseApiURL}/assistanceloadprocess`, parameters);

export const getStudentPeiData = (payload) =>
  apiProvider.get(`${baseApiURL}/getstudentpeidata`, {
    params: {
      ...payload,
    },
  });
export const getTransportationReport = (peiId, analysisServiceId) =>
  apiMipe.get(`api/report/transportation/${peiId}/${analysisServiceId}`);

export const approveAttendance = async (payload) =>
  apiProvider.post(`${baseApiURL}/approveattendance`, payload);

export const getAssistanceDetailInfo = (
  assistanceSummaryId,
  isNormalAssistance = null,
  monthNumber = null,
  year = null
) =>
  apiProvider.get(
    `${baseApiURL}/getassistancedetailinfo/${assistanceSummaryId}`,
    {
      params: {
        isNormalAssistance,
        monthNumber,
        year,
      },
    }
  );

export const getAssistanceDetailPeriods = (assistanceSummaryId) =>
  apiProvider.get(
    `${baseApiURL}/getassistancedetailperiods/${assistanceSummaryId}`
  );

export const getPaymentDetail = (assistanceSummaryId, academicYearId) =>
  apiProvider.get(
    `${baseApiURL}/getpaymentdetail/${assistanceSummaryId}/${academicYearId}`
  );

export const getProgressReport = (assistanceSummaryId) =>
  apiProvider.get(`${baseApiURL}/getprogressreport/${assistanceSummaryId}`);

export const updateAssistanceSummary = async (parameters) =>
  apiProvider.post(`${baseApiURL}/updatePayrollAssistanceSummary`, parameters);

export const analyzedmark = async (parameters) =>
  apiProvider.post(`${baseApiURL}/analyzedmark`, parameters);

export const getAssistanceEventType = () =>
  apiProvider.get(`${baseApiURL}/assistanceeventtype`);

export const getAssistanceEventLog = (id, eventTypeId) =>
  apiProvider.get(`${baseApiURL}/assistanceeventlog/${id}`, {
    params: {
      eventTypeId,
    },
  });

export const getJournalInitFilters = () =>
  apiProvider.get(`${baseApiURL}/journalinitfilters`);

export const getJournal = (academicYearId, statusId, typeId, pageIndex) =>
  apiProvider.get(`${baseApiURL}/paymentjournal/${academicYearId}`, {
    params: {
      statusId,
      typeId,
      pageIndex,
    },
  });
export const denyassistance = async (payload) =>
  apiProvider.post(`${baseApiURL}/denyassistance`, payload);

export const compliancereasons = async () =>
  apiProvider.get(`${baseApiURL}/denyreasons`);

export const loadProcessExist = async () =>
  apiProvider.get(`${baseApiURL}/loadprocessexist`);

export const manualAdjustmentAssistance = async (assistanceSummaries) =>
  apiProvider.post(
    `${baseApiURL}/manualadjustmentassistance`,
    assistanceSummaries
  );

export const additionalPayment = async (parameters) =>
  apiProvider.post(`${baseApiURL}/additionalpayment`, parameters);

export const getJournalReport = (paymentJournalId) =>
  apiProvider.get(`${baseApiReport}/journalreport`, {
    params: {
      paymentJournalId,
    },
  });

export const getRelatedPaymentReasonTypes = async () =>
  apiProvider.get(`${baseApiURL}/relatedpaymentreasontypes`);

export const getPaymentsToRelate = async (
  assistanceSummaryId,
  reasonType,
  studentSieIdOrSsn
) =>
  apiProvider.get(`${baseApiURL}/paymentstorelate/${assistanceSummaryId}`, {
    params: {
      reasonType,
      studentSieIdOrSsn,
    },
  });

export const saveRelatedPayments = async (
  parentAssistanceSummaryId,
  assistanceSummaryIdList
) =>
  apiProvider.post(
    `${baseApiURL}/saverelatedpayments/${parentAssistanceSummaryId}`,
    assistanceSummaryIdList
  );

export const saveFollowUpAssistance = async (parameters) =>
  apiProvider.post(`${baseApiURL}/savefollowupassistance`, parameters);

export const getAssistanceTherapyInfo = async (
  academicYearId,
  studentSieId,
  disciplineTypeCode
) =>
  apiProvider.get(
    `${baseApiURL}/assistancetherapyinfo/${academicYearId}/${studentSieId}/${disciplineTypeCode}`
  );

export const getAssistanceRpInfo = async (academicYearId, studentSieId) =>
  apiProvider.get(
    `${baseApiURL}/assistancerpinfo/${academicYearId}/${studentSieId}`
  );

export const resetPaymentStatus = async (assistanceSummaryId) =>
  apiProvider.get(`${baseApiURL}/resetpaymentstatus/${assistanceSummaryId}`);

export const getBillingAssistance = async (
  studentSieId,
  academicYeardId,
  monthNumber,
  disciplineTypeId,
  payrollReceiveType,
  assistanceSummaryId
) =>
  apiProvider.get(`${baseApiURL}/becabillingassistance`, {
    params: {
      studentSieId,
      academicYeardId,
      monthNumber,
      disciplineTypeId,
      payrollReceiveType,
      assistanceSummaryId,
    },
  });

export const getAssistanceSummaries = async (
  academicYearId,
  studentSieId,
  assistanceSummaryId
) =>
  apiProvider.get(
    `${baseApiURL}/assistanceSummaries/${academicYearId}/${studentSieId}/${assistanceSummaryId}`
  );

export const getAssistanceSummariesForDenyPayments = async (
  academicYearId,
  studentSieId,
  assistanceSummaryId
) =>
  apiProvider.get(
    `${baseApiURL}/assistancesummariesfordenypayments/${academicYearId}/${studentSieId}/${assistanceSummaryId}`
  );

export const getAdditionalPaymentList = async (parameter) =>
  apiProvider.get(`${baseApiURL}/additionalpaymentlist/${parameter}`);

export const getCertificationDocument = (assistanceSummaryId) =>
  apiProvider.get(`${baseApiURL}/visitscertificationdocument`, {
    params: {
      assistanceSummaryId,
    },
  });

export const createPaymentJournal = (academicYearId) =>
  apiProvider.post(`${baseApiURL}/createpaymentjournal/${academicYearId}`);

export const removeManualAdjustment = async (assistanceSummaryId) =>
  apiProvider.post(
    `${baseApiURL}/removemanualadjustment/${assistanceSummaryId}`
  );

export const getPaymentJournalBudgetDetail = (academicYearId) =>
  apiProvider.get(`${baseApiURL}/journalbudgetdetail/${academicYearId}`);

export const getPaymentJournalInfoDetail = (paymentJournalId) =>
  apiProvider.get(`${baseApiURL}/journalinfodetail/${paymentJournalId}`);

export const getPaymentRelationship = async (parameter) =>
  apiProvider.get(`${baseApiURL}/paymentrelationship/${parameter}`);

export const denyJournalPayment = async (journalPaymentId, payload) =>
  apiProvider.post(
    `${baseApiURL}/denyjournalpayment/${journalPaymentId}`,
    payload
  );

export const getPaymentJournalDetailData = async (payload, pageIndex) =>
  apiProvider.get(`${baseApiURL}/paymentjournaldetail`, {
    params: {
      ...payload,
      pageIndex,
    },
  });

export const getPaymentJournalDetailGroupedData = async (payload, pageIndex) =>
  apiProvider.get(`${baseApiURL}/paymentjournaldetailgrouped`, {
    params: {
      ...payload,
      pageIndex,
    },
  });

export const getPaymentJournalGroupedSummary = async (paymentJournalId) =>
  apiProvider.get(
    `${baseApiURL}/paymentjournalgroupedsummary/${paymentJournalId}`
  );

export const savePaymentJournalStudentVoucher = async (payload) =>
  apiProvider.put(`${baseApiURL}/savepaymentjournalstudentvoucher`, payload);

export const savePaymentJournalStudentPaymentReference = async (payload) =>
  apiProvider.put(
    `${baseApiURL}/savepaymentjournalstudentpaymentreference`,
    payload
  );

export const approveJournalPayments = async (
  journalPaymentId,
  assistanceSummaryIdList
) =>
  apiProvider.post(
    `${baseApiURL}/approvejournalpayments/${journalPaymentId}`,
    assistanceSummaryIdList
  );

export const hasJournalAnswerFilesUploaded = async (paymentJournalId) =>
  apiProvider.get(
    `${baseApiURL}/hasjournalanswerfilesuploaded/${paymentJournalId}`
  );

export const setPaymentJournalAsPaid = async (paymentJournalId, paymentDate) =>
  apiProvider.post(
    `${baseApiURL}/setpaymentjournalaspaid/${paymentJournalId}`,
    paymentDate
  );

export const getBudgetedServices = async (academicYearId) =>
  apiProvider.get(`${baseApiURL}/budgetedservices`, {
    params: {
      academicYearId,
    },
  });

export const changePaymentJournalToNew = async (paymentJournalId) =>
  apiProvider.put(
    `${baseApiURL}/changepaymentjournaltonew/${paymentJournalId}`
  );

export const updatePaymentJournal = async (paymentJournalId) =>
  apiProvider.put(`${baseApiURL}/updatepaymentjournal/${paymentJournalId}`);

export const checkPaymentStatus = async (assistanceSummaryId) =>
  apiProvider.get(`${baseApiURL}/checkpaymentstatus/${assistanceSummaryId}`);

export const getPaymentJournalInterfaceFiles = (
  paymentJournalId,
  fileTypeCode
) =>
  apiProvider.get(
    `${baseApiURL}/paymentjournalebtinterfacefiles/${paymentJournalId}/${fileTypeCode}`
  );

export const createPaymentInterfaceFiles = (paymentJournalId) =>
  apiProvider.post(`${baseApiURL}/createebtpaymentfile/${paymentJournalId}`);

export const deleteRecordFromPaymentJournal = async (assistanceSummaryId) =>
  apiProvider.get(
    `${baseApiURL}/deleterecordfrompaymentjournal/${assistanceSummaryId}`
  );

export const createAccountSetupFile = (paymentJournalId, fileTypeCode) =>
  apiProvider.post(
    `${baseApiURL}/createaccountsetupfile/${paymentJournalId}/${fileTypeCode}`
  );

export const createBenefitIssuanceFile = (paymentJournalId, fileTypeCode) =>
  apiProvider.post(
    `${baseApiURL}/createbenefitissuancefile/${paymentJournalId}/${fileTypeCode}`
  );

export const getJornalAccountFile = (interfaceFileId, fileTypeCode) =>
  apiProvider.get(
    `${baseApiURL}/jornalaccountfile/${interfaceFileId}/${fileTypeCode}`
  );

export const movePaymentsToPending = (paymentJournalId, assistanceSummaryIds) =>
  apiProvider.post(
    `${baseApiURL}/movepaymentstopending/${paymentJournalId}`,
    assistanceSummaryIds
  );

export const saveAnswerFiles = async (payload) =>
  apiProvider.post(`${baseApiURL}/saveanswerfiles`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const removefilesFromJournalPayments = (paymentJournalId) =>
  apiProvider.post(
    `${baseApiURL}/removefilesfromjournalpayments/${paymentJournalId}`
  );

export const updateAccountSetupFile = (paymentJournalId) =>
  apiProvider.post(`${baseApiURL}/updateaccountsetupfile/${paymentJournalId}`);

export const changePaymentJournalToProcessed = (paymentJournalId) =>
  apiProvider.post(
    `${baseApiURL}/changepaymentjournaltoprocessed/${paymentJournalId}`
  );

export const sendPaymentJournalToFinance = (paymentJournalId) =>
  apiProvider.post(
    `${baseApiURL}/changepaymentjournaltosenttofinance/${paymentJournalId}`
  );

export const changePaymentJournalToPaid = (paymentJournalId) =>
  apiProvider.post(
    `${baseApiURL}/changepaymentjournaltopaid/${paymentJournalId}`
  );

export const getAvailableJournalsForMove = (paymentJournalId) =>
  apiProvider.get(`${baseApiURL}/availablejournalsformove/${paymentJournalId}`);

export const moveAssistanceSummaryToJournal = (
  assistanceSummaryId,
  targetJournalId
) =>
  apiProvider.post(
    `${baseApiURL}/moveassistancesummarytojournal/${assistanceSummaryId}/${targetJournalId}`
  );

export const deleteInterfaceFileAnswer = (interfaceFileId, fileTypeCode) =>
  apiProvider.delete(
    `${baseApiURL}/deleteinterfacefileanswer/${interfaceFileId}/${fileTypeCode}`
  );

export const getAssistanceDetailService = (assistanceSummaryId) =>
  apiProvider.get(
    `${baseApiURL}/assistancedetailservice/${assistanceSummaryId}`
  );

export const deleteAdditionalPayment = (assistanceSummaryId) =>
  apiProvider.delete(
    `${baseApiURL}/deleteadditionalpayment/${assistanceSummaryId}`
  );

export const removeServiceRelation = (
  assistanceSummaryParentId,
  assistanceSummaryId,
  isParent
) =>
  apiProvider.put(
    `${baseApiURL}/removeservicerelation/${assistanceSummaryParentId}/${assistanceSummaryId}/${isParent}`
  );

export const saveFindingComment = (payload) =>
  apiProvider.post(`${baseApiURL}/savefindingcomment`, payload);

export const getFindingComments = (id) =>
  apiProvider.get(`${baseApiURL}/findingcomments/${id}`);

export const resetPayroll = (id) =>
  apiProvider.post(`${baseApiURL}/resetpayroll/${id}`);

export const updateMillageCompanion = (assistanceSummaryId) =>
  apiProvider.post(
    `${baseApiURL}/updateMillageCompanion/${assistanceSummaryId}`
  );

export const getAssistanceTransportationInfo = async (
  academicYearId,
  studentSieId,
  disciplineTypeCode
) =>
  apiProvider.get(
    `${baseApiURL}/assistancetransportationinfo/${academicYearId}/${studentSieId}/${disciplineTypeCode}`
  );
